/* Use Address Billing Form */
var BillingAddress = (function (CheckoutApiModel, CheckoutSettings) {
	return CheckoutApiModel.extend({

		defaults: {
			'Label': ''
		},

		initialize: function() {
			this._isActive = false;
		},

		isActive: function (isActive) {
			this._isActive = isActive;
			this.trigger('isActive', this._isActive);
		},

		isValid: function () {
			return !!this.get('Label');
		},

		setData: function (data, silent) {
			if (data.Label !== this.get('Label')) {
				this.clear({ silent: true });
				this.set(data, { silent: silent });
			}
		},

		getLabel: function() {
			return (this.get('Label') || '').replace(/\n/g, ' ');
		},

		hasBilling: function() {
			return !!this.get('Label');
		},

		save: function (address) {
			if (address.Label) {
				return api.saveBillingAddress(address).done(this._saved.bind(this, address));
			}
			return new $.Deferred().reject().promise();
		},
		_saved: function (address) {
			this.setData(address, true);
			this.trigger('saved');
		}
	});
})(CheckoutApiModel, CheckoutSettings);
